<template lang="pug">

  app-dialog(v-model="$_show" :header="'Редактировать дело'" @confirm="editCase()" confirmText="Сохранить" width="400")
      v-layout.mt-1(v-if="courtCase")
        v-flex(xs12)
          app-select(v-model="courtCase.gasTableType" :items="caseTableTypes" item-text="title" label="Тип дела"  return-object) 
          app-text-field(v-model="courtCase.number" label="№ дела") 
          app-text-field(v-model="courtCase.lawArticle" label="Статья") 
      v-layout.mt-1
        v-flex(xs8)
          app-date-picker(v-model="sessionForm.eventDate" format="YYYY-MM-DD" :viewFormat="'DD.MM.YYYY'" label="Дата заседания")
        v-flex(xs4)
          //-app-select(v-model="sessionForm.eventTime" :items="timeIntervals" label="Время") 
          app-text-field(v-model="sessionForm.eventTime" type="time" label="Время") 

</template>

<script>
import { AppDialogToggable } from '@/components'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import { caseService } from "@/_services"

export default {
  mixins: [AppDialogToggable],

  data () {
    return {
      sessionForm: {
        eventDate: null,
        eventTime: "8:00"
      }
    }
  },

  mounted() {
    this.$store.dispatch('list/GET_CASE_TABLE_TYPES')
  },

  computed: {
    ...mapState('courtCase', ['courtCase']),
    ...mapGetters('courtCase', ['currentSession']),
    ...mapGetters('list', ['caseTableTypes']),

    timeIntervals () {
      this.setDateAntTimeCuSession()

      var list = []
      for (var i = 8; i < 20; i++) {
        let hour = `0${i}`.slice(-2)
        list.push(`${hour}:00`)
        list.push(`${hour}:30`)
      }
      return list
    },
  },
  
  methods: {
    editCase () {
      caseService.add(this.courtCase).then(courtCase => {
        let currentSession = this.currentSession
        currentSession.eventDate = moment(this.sessionForm.eventDate).format('YYYY-MM-DD') + " " + this.sessionForm.eventTime,
        currentSession.createDate = moment().format('YYYY-MM-DD HH:mm'),
        currentSession.courtCase = courtCase,
        currentSession.name = (currentSession.name ? currentSession.name.split("от")[0] : "1 ") + " от " + moment().format('DD.MM.YYYY HH:mm'),
        
        caseService.addSession(currentSession).then(() => {
          this.$store.dispatch('courtCase/LOAD_CASE', this.courtCase.id)
        })
      })
    },

    setDateAntTimeCuSession () {
      this.sessionForm.eventDate = moment(this.currentSession.eventDate).format('YYYY-MM-DD')
      this.sessionForm.eventTime = moment(this.currentSession.eventDate).format('HH:mm')
    }
  }
}
</script>
